import React from 'react';
import { MdPlayArrow } from 'react-icons/md';
import { useCoach } from './Coach';

/**
 * An empty list that says what to do next: «لا توجد شعب بعد» plus
 * «ورّيني كيف» for the guide that fills it. Used as a Table's emptyText.
 * A role without that guide sees the plain line only.
 */
export default function EmptyGuide({ text, guide }) {
  const { guides, start } = useCoach();
  const x = guides.find((g) => g.id === guide);
  return (
    <span className="help-empty-guide">
      <span>{text}</span>
      {x && (
        <button type="button" onClick={() => start(x.id)} data-guide={`empty-${x.id}`}>
          <MdPlayArrow size={17} /> ورّيني كيف: {x.title}
        </button>
      )}
    </span>
  );
}
